import React, { useState } from 'react';
import { PrivacyPolicy } from '../PrivacyPolicy';
import { TermAndConditions } from '../TermAndConditions';

export default function LandingFooter() {
  const [privacyTrigger, setPrivacyTrigger] = useState(false);
  const [termsTrigger, setTermsTrigger] = useState(false);

  const go = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-brand-line bg-brand-soft">
      <div className="mx-auto max-w-landing px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <img
              src="/static/images/logo-mark-navy.png"
              alt="SchoolCracked"
              className="h-9 w-auto object-contain"
            />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-brand-muted">
              The AI teaching assistant for Cogniz Tech students — ask, upload, and learn with confidence.
            </p>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-brand-ink">Explore</h3>
            <ul className="mt-3 space-y-2 text-sm text-brand-muted">
              <li>
                <button type="button" onClick={() => go('#capabilities')} className="hover:text-brand-navy">
                  What it does
                </button>
              </li>
              <li>
                <button type="button" onClick={() => go('#live')} className="hover:text-brand-navy">
                  Live mode
                </button>
              </li>
              <li>
                <button type="button" onClick={() => go('#how-it-works')} className="hover:text-brand-navy">
                  How it works
                </button>
              </li>
              <li>
                <button type="button" onClick={() => go('#examples')} className="hover:text-brand-navy">
                  Examples
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-brand-ink">Company</h3>
            <ul className="mt-3 space-y-2 text-sm text-brand-muted">
              <li>
                <a
                  href="https://cogniz.tech"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-brand-navy"
                >
                  Cogniz Tech
                </a>
              </li>
              <li>
                <button type="button" onClick={() => setPrivacyTrigger(true)} className="hover:text-brand-navy">
                  Privacy
                </button>
              </li>
              <li>
                <button type="button" onClick={() => setTermsTrigger(true)} className="hover:text-brand-navy">
                  Terms
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-brand-line pt-6 text-xs text-brand-muted">
          © {new Date().getFullYear()} Cogniz Technology. SchoolCracked is part of Cogniz Tech.
        </div>
      </div>

      <PrivacyPolicy privacyTrigger={privacyTrigger} setPrivacyTrigger={setPrivacyTrigger} />
      <TermAndConditions termsTrigger={termsTrigger} setTermsTrigger={setTermsTrigger} />
    </footer>
  );
}
